import React from "react";
import { FiMail, FiDownload, FiArrowUpRight, FiArrowDown } from "react-icons/fi";
import { FaLinkedinIn } from "react-icons/fa";
import resumeLink from "../Assets/CV_aw.pdf";
import Section from "./Section";

const rows = [
  {
    icon: FiMail,
    action: FiArrowUpRight,
    label: "Email",
    value: "me@andreaswallin.com",
    href: "mailto:me@andreaswallin.com",
    primary: true,
  },
  {
    icon: FaLinkedinIn,
    action: FiArrowUpRight,
    label: "LinkedIn",
    value: "andreas-wallin",
    href: "https://www.linkedin.com/in/andreas-wallin-abb4b515a",
    external: true,
  },
  {
    icon: FiDownload,
    action: FiArrowDown,
    label: "CV",
    value: "Download as PDF",
    href: resumeLink,
    external: true,
  },
];

function Contact() {
  return (
    <Section id="contact" label="Contact" wide>
      <p className="[text-wrap:balance] max-w-[30ch] text-2xl md:text-[28px] leading-[1.2] tracking-[-0.02em] text-fg font-semibold">
        Have a project in mind, or just want to say hi?
      </p>
      <p className="mt-3 text-[17px] text-dim">Email is the quickest way to reach me.</p>

      <ul className="mt-7 md:mt-10 border-t border-line">
        {rows.map(({ icon: Icon, action: Action, label, value, href, external, primary }) => (
          <li key={label} className="border-b border-line last:border-b-0">
            <a
              href={href}
              target={external ? "_blank" : undefined}
              rel={external ? "noopener noreferrer" : undefined}
              className="group grid grid-cols-[20px_minmax(0,1fr)_16px] sm:grid-cols-[20px_80px_minmax(0,1fr)_16px] items-center gap-x-4 gap-y-1.5 py-4 -mx-3 px-3 rounded-md hover:bg-surface transition-colors"
            >
              <span
                className="w-5 h-5 flex items-center justify-center row-span-2 sm:row-span-1"
                aria-hidden="true"
              >
                <Icon className={`w-[17px] h-[17px] ${primary ? "text-leaf" : "text-dim"}`} />
              </span>
              <span className="font-mono text-xs text-dim">{label}</span>
              <span
                className={`col-start-2 sm:col-start-3 sm:row-start-1 text-base leading-6 sm:text-[17px] group-hover:text-leaf transition-colors break-words ${
                  primary ? "text-fg font-medium" : "text-body"
                }`}
              >
                {value}
              </span>
              <Action
                className={`col-start-3 row-start-1 row-span-2 sm:col-start-4 sm:row-span-1 w-4 h-4 group-hover:text-leaf transition-colors ${
                  primary ? "text-leaf" : "text-dim"
                }`}
                aria-hidden="true"
              />
            </a>
          </li>
        ))}
      </ul>
    </Section>
  );
}

export default Contact;
